import { createSlice } from "@reduxjs/toolkit";
import { getRedeemCodeList } from "./thunk";

export interface IState {
  lstRedeemCode: any;
  isRedeemCodeLoading: boolean;
  isRedeemCodeSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstRedeemCode: null,
  isRedeemCodeLoading: false,
  isRedeemCodeSuccess: false,

  error: {},
};

const RedeemCodeSlice = createSlice({
  name: "RedeemCode",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Advertisements
    builder.addCase(getRedeemCodeList.pending, (state: IState, action: any) => {
      state.isRedeemCodeLoading = true;
    });
    builder.addCase(
      getRedeemCodeList.fulfilled,
      (state: IState, action: any) => {
        state.lstRedeemCode = action.payload.data;
        state.isRedeemCodeSuccess = true;
        state.isRedeemCodeLoading = false;
      }
    );
    builder.addCase(
      getRedeemCodeList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isRedeemCodeSuccess = false;
        state.isRedeemCodeLoading = false;
      }
    );
  },
});

export default RedeemCodeSlice.reducer;
